/**
 * Created by Olga Eremina on 22.10.2026
 */

const BoardFullHelper = function (logic) {
    this.logic = logic;
    this.type = logic.type;
    this.move = undefined;
    this.timeout = undefined;
    this.dialogue = undefined;
    this.lastTime = BoardFullHelper.getLastTime(this.type);

    const scene = cleverapps.Scenes.GetRunningScene();
    const sceneComponent = ComponentMap.getByName(scene, "Merge2SceneComponent");
    this.hintView = sceneComponent.hintViews.find((view) => view instanceof BoardFullHelper.HINTS[this.type].viewClass);

    cleverapps.availableMove.on(logic.type, this.onHintShown.bind(this));
    cleverapps.availableMove.on("hide", this.onHintHidden.bind(this));
    Merge2.current.on("stop", this.hide.bind(this));
    cleverapps.gameManager.on("pause", this.clearTimeout.bind(this), Merge2.current);
    cleverapps.gameManager.on("resume", this.onResume.bind(this), Merge2.current);
};

BoardFullHelper.prototype.onHintShown = function (move) {
    if (move.algorithm !== this.logic) {
        this.hide();
        return;
    }

    if (this.move) {
        return;
    }

    this.hide();

    if (!this.isAvailable()) {
        return;
    }

    this.timeout = cleverapps.timeouts.setTimeout(this.startTutorial.bind(this, move), BoardFullHelper.DELAY);
};

BoardFullHelper.prototype.onHintHidden = function () {
    this.clearTimeout();

    if (BoardFullHelper.currentHint !== this) {
        this.hide();
    }
};

BoardFullHelper.prototype.onResume = function () {
    const move = cleverapps.availableMove.move;
    if (move && move.algorithm === this.logic) {
        this.onHintShown(move);
    }
};

BoardFullHelper.prototype.isAvailable = function () {
    return Merge2.current.isGameMode()
        && cleverapps.user.checkAvailable(cleverapps.config.availables.BOARD_FULL_TUTORIAL)
        && Merge2.current.field.countEmptySlots() === 0
        && MergeHintLogics.collectCandidates(true).length === 0
        && this.lastTime + BoardFullHelper.COOLDOWN <= Date.now();
};

BoardFullHelper.prototype.save = function () {
    this.lastTime = Date.now();

    const data = cleverapps.dataLoader.load(DataLoader.TYPES.BOARD_FULL_HINT) || {};
    data[this.type] = this.lastTime;
    cleverapps.dataLoader.save(DataLoader.TYPES.BOARD_FULL_HINT, data);
};

BoardFullHelper.prototype.startTutorial = function (move) {
    this.clearTimeout();

    if (cleverapps.availableMove.move !== move || !this.isAvailable()) {
        return;
    }

    if (cleverapps.focusManager.isFocused() || Merge2.current.counter.isActive()) {
        return;
    }

    this.move = move;
    BoardFullHelper.currentHint = this;
    this.hintView.setTutorialMode(true);

    const dialogue = this.dialogue = new MinimalDialogue({
        text: Messages.get("BoardFullHint.intro"),
        okText: Messages.get("BoardFullHint.help"),
        cancelText: Messages.get("BoardFullHint.dismiss"),
        delay: 0,
        position: MinimalDialogue.POSITIONS.TOP,
        persistent: true,
        onOk: this.accept.bind(this),
        onCancel: this.lastTime ? () => cleverapps.tutorial.stop("cancel") : undefined,
        onHelp: () => {
            dialogue.hide();
            BoardFullHelper.openGuide(() => {
                dialogue.createContent();
                dialogue.updatePosition();
                dialogue.showUp();
            });
        }
    });

    (cleverapps.Scenes.GetRunningScene()).addChild(dialogue);
    dialogue.display();

    const tutorial = cleverapps.tutorial.findScenario(BoardFullTutorial.NAME);
    cleverapps.tutorial.startScenario(tutorial);
    this.save();
};

BoardFullHelper.prototype.accept = function () {
    const dialogue = this.dialogue;
    this.dialogue = undefined;

    if (dialogue) {
        dialogue.remove(() => {
            cleverapps.tutorial.trigger("BoardFullHelperAcceptHint");
        });
    }
};

BoardFullHelper.openGuide = function (onClosed) {
    cleverapps.focusManager.display({
        focus: BoardFullHelper.GUIDE_FOCUS,
        control: ["backpackButton"],
        stack: true,
        action: (f) => {
            new GuideWindow({
                name: "BoardFullGuideWindow",
                bundle: bundles.board_full_guide_window
            });
            cleverapps.focusManager.onceNoWindowsListener = () => {
                onClosed && onClosed();
                f();
            };
        }
    });
};

BoardFullHelper.prototype.clearTimeout = function () {
    cleverapps.timeouts.clearTimeout(this.timeout);
    this.timeout = undefined;
};

BoardFullHelper.prototype.hide = function () {
    this.clearTimeout();
    this.move = undefined;

    this.dialogue && this.dialogue.remove();
    this.dialogue = undefined;

    if (BoardFullHelper.currentHint === this) {
        this.hintView.hide(true);
        this.hintView.setTutorialMode(false);
        BoardFullHelper.currentHint = undefined;
    }
};

BoardFullHelper.getLastTime = function (type) {
    return (BoardFullHelper.getData() || {})[type] || 0;
};

BoardFullHelper.getData = function () {
    return cleverapps.dataLoader.load(DataLoader.TYPES.BOARD_FULL_HINT);
};

BoardFullHelper.GUIDE_FOCUS = "BoardFullGuideWindow";
BoardFullHelper.DELAY = 10000;
BoardFullHelper.COOLDOWN = cleverapps.parseInterval("3 days");

BoardFullHelper.HINTS = {
    collectible: {
        text: "BoardFullHint.collectible",
        viewClass: CollectibleHintView
    },
    collectible_last: {
        text: "BoardFullHint.collectible",
        viewClass: CollectibleHintView
    },
    backpack: {
        text: "BoardFullHint.backpack",
        viewClass: BackpackHintView
    },
    remove: {
        text: "BoardFullHint.remove",
        viewClass: RemoveHintView
    }
};

DataLoader.TYPES.BOARD_FULL_HINT = "_board_full_hint";
